module.exports = __webpack_public_path__ + "img/picture_grey.b952a91b.svg";